// extracted by mini-css-extract-plugin
export default {"h5":"H5title_h5__mbOfN","white":"H5title_white__XGJMW"};